import { Component, Inject } from "@angular/core";
import { Tools } from "@app/util/tools";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-network-error-internal',
    template: require('./network.error.internal.component.html')
})

export class NetworkErrorInternalComponent {

    constructor(
        @Inject(Tools) public tools: any,
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(MatDialogRef<NetworkErrorInternalComponent>) public dialogRef: MatDialogRef<NetworkErrorInternalComponent>) {}

    closeDialog(value: any) {
        this.dialogRef.close(value)
    }


}
